import { useAppState } from "../../providers/app-state";
import TimeOptionCheckbox from "./time-option-checkbox";
import Skeleton from "react-loading-skeleton";
import {
    date_step_all_day,
    date_step_all_day_description,
    date_step_delivery_in_closed_hours,
    date_step_delivery_in_closed_hours_description,
    date_step_delivery_in_closed_hours_helper_text,
    date_step_delivery_in_closed_hours_helper_title,
    date_step_waiting,
    date_step_waiting_description,
    date_step_waiting_helper_text,
    date_step_waiting_helper_title
} from "../../lang/da";

const Checkboxes = ({ openSidebar }) => {
    const { state } = useAppState();

    if (!state.selectedDate) {
        return <Skeleton
            height={80}
        />
    }

    return (
        <div
            className="flex flex-row flex-wrap bg-white shadow-md divide-y md:divide-y-0 md:divide-x w-full"
        >
            <div
                className="basis-full md:basis-1/3"
            >
                <TimeOptionCheckbox
                    onQuestionMarkPress={() => {
                        openSidebar(
                            <div
                                className="text-white px-5 space-y-3"
                            >
                                <p
                                    className="text-xl"
                                >
                                    {
                                        date_step_delivery_in_closed_hours_helper_title
                                    }
                                </p>
                                <p
                                    className="font-light"
                                >
                                    {
                                        date_step_delivery_in_closed_hours_helper_text
                                    }
                                </p>
                            </div>
                        )
                    }}
                    option={4}
                    optionalInfo={date_step_delivery_in_closed_hours_description || null}
                >
                    {
                        date_step_delivery_in_closed_hours
                    }
                </TimeOptionCheckbox>
            </div>
            <div
                className="basis-full md:basis-1/3"
            >
                <TimeOptionCheckbox
                    option={2}
                    optionalInfo={`${date_step_all_day_description} 7.30-8.00 til ${state.selectedDate.day() === 5 ? "15.30" : "16.30"}`}
                    campaignText="Kundernes favorit"
                >
                    {
                        date_step_all_day
                    }
                </TimeOptionCheckbox>
            </div>
            <div
                className="basis-full md:basis-1/3"
            >
                <TimeOptionCheckbox
                    option={1}
                    optionalInfo={date_step_waiting_description || null}
                    onQuestionMarkPress={() => {
                        openSidebar(
                            <div
                                className="text-white px-5 space-y-3"
                            >
                                <p
                                    className="text-xl"
                                >
                                    {
                                        date_step_waiting_helper_title
                                    }
                                </p>
                                <p
                                    className="font-light"
                                >
                                    {
                                        date_step_waiting_helper_text
                                    }
                                </p>
                            </div>
                        )
                    }}
                >
                    {
                        date_step_waiting
                    }
                </TimeOptionCheckbox>
            </div>
        </div>
    )
}

export default Checkboxes;

